import type { POI } from '../reducers/poiReducer';
import type { CustomerPOIDto } from './PoiMapper';

export const mapCategory = (category?: string) => {
    if (!category) {
        return;
    }

    switch (category.toLowerCase().replace('_', ' ')) {
        case 'customer':
            return 'CUSTOMER' as const;
        case 'partner':
            return 'PARTNER' as const;
        case 'my company':
            return 'MY_COMPANY' as const;
        case 'my misc/others':
            return 'MISC' as const;
        default:
            return 'MISC';
    }
};

export const mapToDtoCategory = (category?: string) => {
    if (!category) {
        return;
    }

    switch (category) {
        case 'CUSTOMER' as const:
            return 'Customer';
        case 'PARTNER' as const:
            return 'Partner';
        case 'MY_COMPANY' as const:
            return 'My company';
        case 'MISC' as const:
            return 'My misc/others';
        default:
            return 'My misc/others';
    }
};

export const mapCategoriesFromPOIDtoToPOI = (category: CustomerPOIDto['category']): POI['category'] => {
    switch (category) {
        case 'CUSTOMER':
            return 'CUSTOMER';
        case 'MY_COMPANY':
            return 'MY_COMPANY';
        case 'PARTNER':
            return 'PARTNER';
        case 'MISC':
            return 'MISC';
        default:
            return undefined;
    }
};
